import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShieldAlert, ArrowLeft } from "lucide-react";

export default function AccessDenied() {
  const navigate = useNavigate();

  // Safety net: if someone lingers on /admin without admin role, auto-bounce
  // back to the dashboard after a short window.
  useEffect(() => {
    const t = setTimeout(() => navigate("/", { replace: true }), 5000);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#05050A] px-4">
      <div className="w-full max-w-md text-center" data-testid="access-denied-screen">
        <div className="mb-6 flex flex-col items-center gap-3">
          <div className="w-12 h-12 rounded-sm border border-[#FF3B30]/40 bg-[#FF3B30]/10 flex items-center justify-center">
            <ShieldAlert size={22} strokeWidth={1.5} className="text-[#FF3B30]" />
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-[#FF3B30]">403 · Forbidden</div>
            <h1 className="text-2xl font-semibold tracking-tight mt-1">Admin access required</h1>
          </div>
        </div>
        <p className="text-sm text-[#A0A0AB] leading-relaxed">
          You don't have permission to view this page.
          Only administrators can access the Admin Panel.
        </p>
        <div className="mt-6 text-[10px] uppercase tracking-widest text-[#71717A]">
          Redirecting to dashboard in a few seconds…
        </div>
        <div className="mt-6">
          <Link
            to="/"
            replace
            data-testid="access-denied-home-btn"
            className="inline-flex items-center gap-2 px-3 py-2 rounded-sm border border-border bg-[#1A1A22] hover:bg-[#262633] text-sm"
          >
            <ArrowLeft size={14} strokeWidth={1.5} /> Back to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
